$(document).ready(function () {
  const MAX_RETRIES = 10; // Maximum number of retry attempts
  const INITIAL_DELAY = 200; // Initial delay in ms
  const BACKOFF_FACTOR = 1.5; // How much to increase delay each retry
  
  const applyPriceUpdate = () => {
      $('.tolstoy-product-tile-title').each(function () {
          const titleText = $(this).text().trim();

          if (/\(3-Month\)/.test(titleText)) {

              // Traverse up and locate the container
              const container = $(this).closest('tolstoy-carousel > div > div.tolstoy-carousel-videos-container > div > div > div.tolstoy-product-content > div:nth-child(1) > div > div');
              const subtitleElement = container.find('.tolstoy-product-tile-subtitle');

              if (subtitleElement.length && !subtitleElement.data('modified')) {
                  const priceText = subtitleElement.text().trim();

                  const priceNumber = parseFloat(priceText.replace('$', ''));
                  if (!isNaN(priceNumber)) {
                      const multipliedPrice = (priceNumber * 2);

                      subtitleElement.html(`$${multipliedPrice}`);
                      subtitleElement.data('modified', true);
                  } 
              } 
          }
      });
  };

  const checkElementsAndApply = (attempt = 0, delay = INITIAL_DELAY) => {
      console.log(`Checking for elements (attempt ${attempt + 1})...`);
      
      // Check if the carousel container exists
      const carouselContainer = $('.tolstoy-carousel-videos-container');
      
      if (carouselContainer.length) {
          console.log('Carousel container found! Applying price updates...');
          
          setInterval(() => {
              applyPriceUpdate();
          }, 1000);
          
          // Set up MutationObserver for future changes
          console.log('Setting up MutationObserver for carousel...');
          const observer = new MutationObserver(() => {
              console.log('Mutation detected — running price update again.');
              applyPriceUpdate();
          });
          
          observer.observe(carouselContainer[0], {
              childList: true,
              subtree: true,
              attributes: true,
              characterData: true
          });
          
          return; // Success - exit the retry loop
      }
      
      // If elements not found and we haven't exceeded max retries
      if (attempt < MAX_RETRIES - 1) {
          const nextDelay = Math.min(delay * BACKOFF_FACTOR, 5000); // Cap at 5s
          
          setTimeout(() => {
              checkElementsAndApply(attempt + 1, nextDelay);
          }, delay);
      }
  };

  // Start the initial check
  checkElementsAndApply();
});